<template>
    <div class="individual_list" v-loading="loading">
        <div class="individual_list_box">
             <div class="title_box">
                <!-- <img src="../../assets/img/login/Frame.png" alt=""> -->
                <span class="span1">首页</span> > <span class="span2">企业法务</span>
             </div>
             <div class="check_box">
                <div class="check_felx">
                    <div class="check_title">办理地址</div>
                    <div class="check_list" :class="{'check_list_minh':bldz_show,'check_list_maxh':!bldz_show}">
                        <div class="check_item" :class="{check_item_ac:item.id==bldz_ac.id}" v-for="(item,index) in bldz_list" :key="index" @click="handle_bldz(item)">{{ item.name }}</div>
                    </div>
                    <div class="check_show" :class="{'check_show2':bldz_show}" @click="handle_bldz_show">
                        <img src="@/assets/img/index/legal/check_show.png" alt="">
                    </div>
                </div>
                <div class="check_felx">
                    <div class="check_title">业务类型</div>
                    <div class="check_list" :class="{'check_list_minh':ywlx_show,'check_list_maxh':!ywlx_show}">
                        <div class="check_item" :class="{check_item_ac:item.id==ywlx_ac.id}" v-for="(item,index) in ywlx_list" :key="index" @click="handle_ywlx(item)">{{ item.title }}</div>
                    </div>
                    <div class="check_show" :class="{'check_show2':ywlx_show}" @click="handle_ywlx_show">
                        <img src="@/assets/img/index/legal/check_show.png" alt="">
                    </div>
                </div>

                <div class="check_felx">
                    <div class="check_title">已选择</div>
                    <div class="check_ac_flex">
                        <div class="check_ac_box" v-if="bldz_ac.id">
                            {{ bldz_ac.name }}
                            <img src="../../../assets/img/login/clear.png" alt="" @click="ac_clear('bldz_ac')">
                        </div>
                        <div class="check_ac_box" v-if="ywlx_ac.id">
                            {{ ywlx_ac.title }}
                            <img src="../../../assets/img/login/clear.png" alt="" @click="ac_clear('ywlx_ac')">
                        </div>
                        <div class="chack_ac_clear" @click="handle_clear">清空</div>
                    </div>
                </div>
             </div>
             <div class="list_box">
                <div class="list_left">
                    <div class="list_item" v-for="(item,index) in lists" :key="index">
                        <div class="item_imgs" @click="handle_detial(item)">
                            <img :src="item.thumb" alt="">
                        </div>
                        <div class="item_info">
                            <div class="item_info_top">
                                <div class="info_title">
                                    {{ item.title }}
                                    <img src="@/assets/img/index/legal/title_bg.png" alt="">
                                </div>
                                <div class="info_const">
                                        {{ item.desc }}
                                </div>
                                <div class="info_tages">
                                    <div class="tages" v-if=" (item.cate1||{}).title">{{ item.cate1.title }}</div>
                                    <div class="tages" v-if=" (item.cate2||{}).title">{{ (item.cate2||{}).title }}</div>
                                    <div class="tages" v-if=" (item.cate3||{}).title">{{ (item.cate3||{}).title }}</div>
                                </div>
                            </div>
                            <div class="item_info_bom">
                                <div class="price_flex">
                                    <div class="prices">{{ item.price }}</div>
                                    <div class="nums">销量 {{ item.sale_num }}</div>
                                </div>
                                <div class="btns_flex">
                                    <div class="btns1" @click="handle_check(item,1)">预约律师</div>
                                    <div class="btns2" @click="handle_check(item,2)">在线委托</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pages_box">
                        <div class="btns" @click="handle_pages(1)">首页</div>
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pages.page"
                            background
                            :page-size="pages.limit"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                        <div class="btns"  @click="handle_pages(last_page)">尾页</div>
                    </div>
                </div>
                <div class="list_right">
                    <legal_new ref="legal_new"></legal_new>
                </div>
             </div>
        </div>
        <legal_check ref="legal_check"></legal_check>

    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
import legal_new from '@/components/Legal/legal_new.vue'//右边
import legal_check from '@/components/Legal/legal_check.vue'//选择
 

export default {
    components: {
        legal_new,
        legal_check
        
    },
    name: "homes",
    data() {
        return {
            loading:false,
            bldz_list:[],//办理地址列表
            bldz_ac:{},//办理地址的选中
            bldz_show:false,//办理地址的显示隐藏

            ywlx_list:[],//业务类型
            ywlx_ac:{},//业务类型的选中
            ywlx_show:false,//业务类型的显示隐藏
            lists:[],
            last_page:0,
            total:0,
            pages:{
                page:1,
                limit:10,
            },
        }
    },
    computed: {
       
    },
    watch: {
        
    },
    created() {
        this.get_cause_list()
        this.get_area()
        if(!this.$route.query.id){
            this.get_list()
        }
    },
    methods: {
         //获取地区列表
         get_area(){
            this.loading=true
            this.$api("getChinaArea", {
                parent_id:1,
				type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('地址',res)
                if (res.code == 1) {
                    this.bldz_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
         //获取分类
         get_cause_list(){
            this.loading=true
            this.$api("cause", {
				type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('案由',res)
                if (res.code == 1) {
                    this.ywlx_list=res.data
                    if(this.$route.query.id){
                        this.ywlx_list.forEach((e)=>{
                            if(e.id==this.$route.query.id){
                                this.ywlx_ac=e
                            }
                        })
                       this.get_list()
                    }
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_bldz_show(){
            this.bldz_show=!this.bldz_show
          

        },
        handle_ywlx_show(){
            this.ywlx_show=!this.ywlx_show
           
        },
        handleSizeChange(e){
            console.log('条数',e)     
            this.pages.page=1
            this.get_list()       
        },
        handleCurrentChange(e){
            console.log('页数',e)
            this.pages.page=3
            this.get_list()
        },
        handle_pages(i){
            console.log('首页尾页',i)
            this.pages.page=i
            this.get_list()
        },
        handle_bldz(item){
            this.bldz_ac=item
            this.pages.page=1
            this.get_list()
        },
        handle_ywlx(item){
            this.ywlx_ac=item
            this.pages.page=1
            this.get_list()

        },
        ac_clear(text){
            this[text]={}
            this.pages.page=1
            this.get_list()
 
        },
        //跳转详情
        handle_info(item){
            this.$router.push({
                path:'/lawyer_detial',
                query:{},
            })
        },
        //咨询
        handle_check(item,i){
            this.$refs.legal_check.handle_open(item,i,2)
        },
        handle_end(){
            console.log('回调')
        },
        handle_detial(item){
            this.$router.push({
                path:'/enterprise_detial',
                query:{
                    id:item.id
                }
            })
        },
        handle_clear(){
            this.bldz_ac={}
            this.ywlx_ac={}
            this.pages.page=1
            this.get_list()    
        },
        get_list(){
            this.loading=true
            this.$api("servePros", {
				type:2,
                province:this.bldz_ac.id||'',
                cateid:this.ywlx_ac.id||'',
			}, "get").then((res) => {
                this.loading = false
                console.log('个人法务',res)
                if (res.code == 1) {
                    this.lists=res.data.data
                    this.total=res.data.total
                    this.last_page=res.data.last_page
                } else {
                    alertErr(res.msg)
                }
            });
        },
    },

}
</script>
<style scoped lang="less">
.individual_list{
    width: 100%;
    // height: 680px;
    background-color: #F5F5F5;
    padding:21px ;
    padding-bottom: 100px;
    .individual_list_box{
        width: 1440px;
        margin: auto;
        .title_box{
            padding-bottom: 21px;

            display: flex;
            align-items: center;

            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            .span1{
                cursor: pointer;
                margin-right: 10px;
            }
            .span2{
                cursor: pointer;
                margin-left: 10px;
            }
            img{
                margin-right: 10px;
            }
        }
        .check_box{
            width: 1440px;
            // height: 261px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            padding:0 32px;
            .check_felx{
                display: flex;
                // align-items: center;
                padding: 24px 0px 14px 0;
                border-bottom: 1px solid #EEEEEE ;
                .check_title{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #999999;
                    width: 90px;
                    flex-shrink: 0;
                }
                .check_list{
                    display: flex;
                    flex-wrap: wrap;
                    width: 1260px;
                    .check_item{
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        margin-right: 40px;
                        margin-bottom: 10px;
                        &:hover{
                            color: #377CFD;
                        }
                    }
                    .check_item_ac{
                        color: #377CFD;

                    }
                }
                .check_list_maxh{
                    height: 60px;
                    overflow: hidden;
                }
                .check_list_minh{
                    min-height: 60px;
                }
                .check_show{
                    width: 20px;
                    height: 20px;
                    flex-shrink: 0;
                    img{
                        width: 20px;
                        height: 20px;
                        cursor: pointer;
                    }
                }
                .check_show2{
                    img{
                        transform: rotate(-180deg);
                    }
                }
                .check_ac_flex{
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                    .check_ac_box{
                        // width: 102px;
                        padding: 0 10px;
                        height: 29px;
                        background: #F8F8F8;
                        border-radius: 0px 0px 0px 0px;
                        margin-right: 11px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        
                        font-weight: 400;
                        font-size: 14px;
                        color: #656565;
                        img{
                            width: 12px;
                            height: 12px;
                            margin-left: 14px;
                            cursor: pointer;
                        }

                    }
                    .chack_ac_clear{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        cursor: pointer;
                    }
                }
            }
        }
        .list_box{
            display: flex;
            justify-content: space-between;
            padding-top: 24px;
            .list_left{
                width: 1000px;
                // height: 2354px;
                background: #FFFFFF;
                border-radius: 0px 0px 0px 0px;
                padding: 32px 32px 40px 32px ;
                .list_item{
                    padding-bottom: 32px; 
                    border-bottom: 1px solid #EEEEEE;
                    display: flex;
                    align-items: center;
                    margin-bottom: 32px;
                    .item_imgs{
                        width: 184px;
                        height: 184px;
                        flex-shrink: 0;
                        cursor: pointer;
                        img{
                            width: 184px;
                            height: 184px;
                        }
                    }
                    .item_info{
                        flex-shrink: 0;
                        flex: 1;
                        display: flex;
                        flex-wrap: wrap;
                        align-content: space-between;
                        padding-left: 28px;
                        height: 184px;

                        .item_info_top{
                            .info_title{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 18px;
                                color: #333333;
                                display: flex;
                                align-items: center;
                                img{
                                    margin-left: 10px;
                                    width: 14px;
                                    height: 18px;
                                }
                            }
                            .info_const{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp:1;
                                -webkit-box-orient: vertical;
                                margin-top: 14px;
                            }
                            .info_tages{
                                display: flex;
                                align-items: center;
                                margin-top: 22px;
                                .tages{
                                    margin-right: 10px;
                                    padding: 4px 12px;
                                    background: #FDF6EC;
                                    border-radius: 3px 3px 3px 3px;
                                    border: 1px solid #FFAA00;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 12px;
                                    color: #FFAA00;

                                }
                            }
                        }
                        .item_info_bom{
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            .price_flex{
                                display: flex;
                                align-items: self-end;
                                .prices{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 28px;
                                    color: #FD4C5C;
                                }
                                .nums{
                                    padding-left: 20px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #999999;
                                }
                            }
                            .btns_flex{
                                display: flex;
                                align-items: center;
                                .btns1{
                                    width: 134px;
                                    height: 36px;
                                    background: #FFFFFF;
                                    border-radius: 4px 4px 4px 4px;
                                    border: 1px solid #377CFD;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 14px;
                                    color: #377CFD;
                                    text-align: center;
                                    line-height: 36px;
                                    margin-left: 10px;
                                    cursor: pointer;
                                }
                                .btns2{
                                    width: 134px;
                                    height: 36px;
                                    background: #377CFD;
                                    border-radius: 4px 4px 4px 4px;
                                    border: 1px solid #377CFD;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 14px;
                                    color: #FFFFFF;
                                    text-align: center;
                                    line-height: 36px;
                                    margin-left: 10px;
                                    cursor: pointer;
                                }

                            }
                        }
                    }
                }
            }
            .list_right{

            }

            
        }
        .pages_box{
            width: 100%;
            height: 100px;
            // background-color: red;
            display: flex;
            align-items: center;
            justify-content: center;
            /deep/.el-pagination{
                .el-pager{
                    .number {
                        background-color: #FFFFFF;
                    }
                    .active{
                        background-color: #377CFD;
                    }
                }
            }
            .btns{
                width: 40px;
                height: 32px;
                background: #FFFFFF;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #EEEEEE;  
                font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                font-weight: normal;
                font-size: 14px;
                color: #7A7A7A;
                text-align: center;
                line-height: 32px;
                cursor: pointer;
            }
        }
         
        
        
    }
    
}

</style>